module.exports = __webpack_public_path__ + "static/media/banner-home.05534e8f.svg";